import { createAxiosInstance } from 'lg-vue-components/services/axiosRequest';

class PortalService {
  constructor() {
    this.axiosRequest = createAxiosInstance(process.env.VUE_APP_API || '/Api.Autoatendimento/');
    this.urlBase = 'portal';
  }

  getLogotipo() {
    return new Promise((resolve) => {
      try {
        this.axiosRequest.get(`${this.urlBase}/logotipo`).then((response) => {
          resolve(response.data ? response.data.url : null);
        });
      } catch {
        resolve(null);
      }
    });
  }
}
export default new PortalService();
